enum DBSaveStatus {
  New,
  Changed,
  Saved,
  Deleted,
}

export default DBSaveStatus;